import * as React from "react";
import * as ReactDOM from "react-dom";

import { BrowserRouter, Switch, Route } from 'react-router-dom';

// Authentication Views
import NotAuthorizedView from "~auth/views/not-authorized";
import LoginView from "~auth/views/login";
import LoginRenderer from "~auth/views/login-card-renderer";
import ResetPasswordWithToken from "~auth/views/reset-password-with-token";
import ForgotPasswordView from "~auth/views/forgot-password";
import MaintenanceMode from "~auth/views/maintenance-mode";

// Bulletins Views
import InvitePortalUserView from "~users/views/invite-portal-user";
import InviteBulkPortalUserView from "~users/views/invite-bulk-portal-user";

import UserRegisterView from "~users/views/register-portal-user";

// import UserSelfRegisterView from "~users/views/self-register-portal-user";
import UserSelfRegisterView from "~users/views/unsolicited-user-registration";
import UsersAdminView from "~users/views/user-admin";
import Preferences from "~users/views/preferences";
import GroupsAdminView from "~users/views/group-admin";
import FormsAdminView from "~forms/views/form-admin";
import DashboardView from "~dashboard/views/dashboard";
import BulletinsAdminView from "~bulletins/views/bulletin-admin";
import BulletinsList from "~bulletins/views/user-bulletins-list";
import LinksAdminView from "~links/views/links-admin";
import LinksList from "~links/views/user-links-list";
import FaqList from '~faq/views/faq-list';
import FAQAdminView from "~faq/views/faq-admin";

import UserGroupFeatureReport from '~users/views/user-group-feature-report';

import TemplatesAdminView from "~templates/views/template-admin";
import DefinitionSectionViewer from '~forms/views/definition-section-view';

import FeatureProxyAdmin from "~users/views/feature-proxy-admin"

import FeatureProxyAssignment from "~users/views/preferences-proxy-assignment"

FeatureProxyAssignment.register()
LoginRenderer.register()

ReactDOM.render(( 
  <BrowserRouter>
    <Switch>

      <Route path='/feature-proxy/admin/:id' component={props => <FeatureProxyAdmin {...props}/>} />
      <Route path='/feature-proxy/admin' component={props => <FeatureProxyAdmin {...props}/>} />
      
      {/* Authentication Module Views (imported from ~auth) */}
      {/* <Route path='/not-authorized' component={props => <NotAuthorizedView {...props} />}/> */}
      <Route path='/not-authorized' component={props => <NotAuthorizedView {...props}/>} />
      <Route path='/login' component={props => <LoginView {...props} />}/>
      <Route path='/users/reset/:id' component={props => <ResetPasswordWithToken {...props} />}/>
      <Route path='/maintenance-mode' component={MaintenanceMode}/>

      {/* Users Module Views (imported from ~templates) */}
  
      <Route path='/users/report/features' component={props => <UserGroupFeatureReport {...props} />}/>
      <Route path='/users/invite/bulk' component={props => <InviteBulkPortalUserView {...props} />}/>
      <Route path='/users/invite/:id' component={props => <InvitePortalUserView {...props} />}/>
      {/*<Route path='/users/register/self' component={props => <UsersSelfRegisterView {...props} />}/>*/}
      <Route path='/users/register/:id' component={props => <UserRegisterView {...props} />}/>
      <Route path='/users/self-register/:id' component={props => <UserSelfRegisterView {...props} />}/>
      <Route path='/users/self-register' component={props => <UserSelfRegisterView {...props} />}/>
      
      
      {/* <Route path='/users/admin' component={props => <UsersAdminView {...props} />}/> */}

      <Route path='/users/admin/:id' component={props => <UsersAdminView {...props} />}/>
      <Route path='/users/admin' component={props => <UsersAdminView {...props} />}/>
      <Route path='/groups/admin/:id' component={props => <GroupsAdminView {...props} />}/>
      <Route path='/groups/admin' component={props => <GroupsAdminView {...props} />}/>


      {/* Bulletins Module Views (imported from ~bulletins) */}
      <Route path='/bulletins/admin/:id' component={props => <BulletinsAdminView {...props} />}/>
      <Route path='/bulletins/admin' component={props => <BulletinsAdminView {...props} />}/>
      <Route path='/bulletins/list' component={props => <BulletinsList {...props} />}/>

      {/* Bulletins Module Views (imported from ~links) */}
      <Route path='/links/admin/:id' component={props => <LinksAdminView {...props} />}/>
      <Route path='/links/admin' component={props => <LinksAdminView {...props} />}/>
      <Route path='/links/list' component={props => <LinksList {...props} />}/>

      {/* FAQ Module Views (imported from ~faq) */}
      <Route path='/faq/admin/:id' component={props => <FAQAdminView {...props} />}/>
      <Route path='/faq/admin' component={props => <FAQAdminView {...props} />}/>
      <Route path='/faq/list' component={props => <FaqList {...props} />}/>

      {/* Forms Module Views (imported from ~forms) */}
      <Route path='/forms/admin/:id' component={props => <FormsAdminView {...props} />}/>
      <Route path='/forms/admin' component={props => <FormsAdminView {...props} />}/>

      {/* Definition Section External Viewer */}
      <Route path='/forms/definition-view' component={props => <DefinitionSectionViewer {...props} />}/>

      {/* Templates Module Views (imported from ~templates) */}
      <Route path='/templates/admin/:id' component={props => <TemplatesAdminView {...props} />}/>
      <Route path='/templates/admin' component={props => <TemplatesAdminView {...props} />}/>
  

      {/* User Module Views (imported from ~users) */}
      {/* <Route path='/not-found' component={props => <NotFoundView {...props} />}/> */}
      <Route path='/forgot-password' component={props => <ForgotPasswordView {...props} />}/>
      {/* <Route path='/portal-user-registration/:token' component={props => <PortalUserRegistration {...props} />}/> */}
			{/* <Route path='/portal-user-registration' component={props => <PortalUserRegistration {...props} />}/> */}
      {/* <Route path='/portal-user-invite' component={props => <PortalUserInvite {...props} />}/> */}
      <Route path='/preferences' component={props => <Preferences {...props} />}/>

      
      {/* <Route path='/subscriptions/:id/:step' component={props => <SubscriptionEditView {...props} />}/> */}
      {/* <Route path='/subscriptions/:id' component={props => <SubscriptionEditView {...props} />}/> */}
      {/* <Route path='/faqs/:areaKey' component={props => <FaqView {...props} />}/> */}
      {/* <Route path='/faqs' component={props => <FaqView {...props} />}/> */}
      {/* <Route path='/suggestions/:areaKey' component={props => <SuggestionView {...props} />}/> */}
      {/* <Route path='/suggestions' component={props => <SuggestionView {...props} />}/> */}
      <Route path='*' component={props => <DashboardView {...props} />}/>
    </Switch>
  </BrowserRouter>
), document.getElementById('container'))
